import Constants from 'expo-constants';

import { env } from '@/util/env';

/**
 * Deep link scheme for the Primum app.
 * Used for handling primum:// URLs on mobile devices.
 */
export const DEEP_LINK_SCHEME = `${Constants.expoConfig?.scheme ?? 'primum'}://`;

export const EDIT_PROFILE_PROFESSIONAL_URL = (id: string | number) =>
  `https://${env.EXPO_PUBLIC_APP_WEB_DOMAIN}/profile/${id}/professional`;

export const DELETE_ACCOUNT_URL = 'https://join.primum.co/accountmgmt/delete';
export const MARKETING_SITE_URL = 'https://www.primum.co';
export const PRIVACY_POLICY_URL = 'https://www.primum.co/privacy-policy';
export const TERMS_OF_USE_URL = 'https://www.primum.co/terms-of-use';

export const APPLE_APP_STORE_LINK = `https://apps.apple.com/us/app/arro-credit-your-way/id${env.EXPO_PUBLIC_APP_STORE_CONNECT_ID}`;
export const GOOGLE_PLAY_STORE_LINK = `https://play.google.com/store/apps/details?id=${env.EXPO_PUBLIC_APP_BUNDLE_ID}`;

export {
  GENERAL_EMAIL_ADDRESS,
  GENERAL_EMAIL_LINK,
  SUPPORT_EMAIL_ADDRESS,
  SUPPORT_EMAIL_LINK,
} from './support';

export const INQUIRY_TUTORIAL_VIDEO_URL = 'https://vimeo.com/1109703544?share=copy';

export const DEMO_VIDEO_URL = 'https://player.vimeo.com/video/1109703544';

export const DEMO_VIDEO_PATHS = {
  INQUIRY_DEMO: 'demos/inquiry-demo-v1.mp4',
} as const;

export const REFERRAL_BASE_URL = `https://${env.EXPO_PUBLIC_APP_WEB_DOMAIN}/create-account?referred_by=`;

export const COMMUNITY_URL = `https://${env.EXPO_PUBLIC_APP_WEB_DOMAIN}/community`;
